/*
document.addEventListener("DOMContentLoaded", function () {
  console.log('magnefico-product-custom.js loaded');
});
*/

// HIDE ADD TO CART

document.addEventListener("DOMContentLoaded", function () {
  const productDetail = document.querySelector(".product_detail");
  const fixedBar = document.querySelector(".product_fixed_bar");

  if (!productDetail || !fixedBar) return; // safety check

  // Start hidden
  fixedBar.style.display = "none";

  // Use IntersectionObserver for performance
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // product_detail is visible → hide bar
          fixedBar.style.display = "none";
        } else {
          // product_detail not visible → show bar
          fixedBar.style.display = "block";
        }
      });
    },
    {
      threshold: 0, // triggers as soon as element leaves viewport
    }
  );

  observer.observe(productDetail);
});
